<template>
    <div class="flex flex-col items-center">
      <div class="custom-alert mb-4">
        <div>
          <strong>Atenção!</strong> 
        </div>
        <div class="separation-line"></div>
        <span>
          Caso seja sua primeira autenticação, gere o Qrcode e insira o código que aparecerá no Google Authenticator em seu próximo login!
          OBS: Sempre que a verificação for desativada e ativada novamente, será necessário gerar um novo Qrcode!
        </span> 
      </div>
      <ol class="text-left">
        <li class="mb-2" id="option1">
          1 - Abra o Google Authenticator no celular
        </li>
        <li class="mb-2">
          2 - Selecione a opção <strong>Adicionar um Código</strong>
        </li>
        <li class="mb-2">
          3 - Selecione a opção <strong>Ler um código QR</strong>
        </li>
        <li class="mb-2">
          4 - Aponte a câmera do seu celular para o QRCode abaixo
        </li>
        <li class="mb-2">
          5 - No proxímo login será solicitado o <strong>Código</strong>
        </li>
      </ol>
      <div class="mt-3 mb-3 vs-con-loading__container" id="div-with-loading">
        <img v-if="showQRCode" :src="qrCodeSVG" width="100%" height="100%" />
      </div>
      <div class="flex space-x-2 mt-3">
        <vs-button @click="generateQRCode" class="generateQRCode" color="success" type="filled">Gerar QR Code</vs-button>
        <vs-button @click="authenticationTwoFactor" class="generateQRCode" color="primary" type="filled" v-if="sendButtonDisabled" >Enviar Código de Verificação</vs-button>
    </div>
    <vs-popup
        title=""
        :active.sync="showModal"
        :button-close-hidden="true"
        style="border-radius: 10px !important;"
        class="sizePopup"
        >
        <div>
            <span style="display: flex;">
                <vs-icon @click="backToQrCode" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
                <p class="ml-2" style="font-size: 16px; width: 400px;">Faça corretamente a autenticação!</p>
                <vs-icon @click="closePopup(false)" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; margin-left: 200px; cursor: pointer;"></vs-icon>
                
            </span>
        </div>
        <div>
        <div style="display: flex; align-items: center;">
          <vs-input
            v-validate="'required|min:6'"
            v-if="verifyActivity" 
            v-model="googleSecret" 
            label="Código" icon-no-border icon="icon-user-check" 
            icon-pack="feather" 
            @keydown.enter="checkToLogin"
          />
        </div>
          <div class="flex flex-wrap justify-between my-5 mb-3">
            <vs-button @click="validateSecretKey">
              Enviar
            </vs-button>
          </div>
        </div>
        </vs-popup>
    </div>
  </template>
  
  <script>
  import vue from '@/main'
  export default {
    props: {
      verifyActivity: String,
    },
    data() {
      return {
        showQRCode: false,
        qrCodeSVG: "",
        timeOutDetected: false,
        verifyActivity: false,
        showModal: false,
        sendButtonDisabled: false,
        googleSecret: '',
        messageResponse: ''
      };
    },
    methods: {
      backToQrCode(){
        this.$emit('backToQrCode')
        this.showModal = false
      },
      async getUsers() {
          try {
            await this.$store.dispatch('getAllUsers')
            const response = this.$store.state.users.users
            return response
          } catch (Exception) {
            return []
          }
      },
      async generateQRCode() {
        await this.getUsers();
        setTimeout(() => {
            this.sendButtonDisabled = true;
          }, 1500);
        const email = localStorage.getItem('email');
        const response = await this.getUsers()
        const result = response.filter(item => item.email === email)
        const role = result[0].role.display_name
        const id = result[0].id
        const token = localStorage.getItem('token')
        localStorage.setItem('twoFactor', String(this.verifyActivity));
        this.showQRCode = true,
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 0.6
        })
        try {
            await this.$store.dispatch('activityTwoFactor', {id: id, token: token, alterObject: {"twofactor_activity": this.verifyActivity,  "identify": 0, "role": role, "email": email}})
            const response = await this.getUsers()
            const result = response.filter(item => item.email === email)
            this.qrCodeSVG = ""
            this.timeOutDetected = false
            const qrCodeBase64 = result[0].qrcode_twofactor
            this.qrCodeSVG = "data:image/svg+xml;base64," + qrCodeBase64;
            this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            this.$vs.notify({
              title: 'Sucesso!',
              text: 'QrCode Gerado com sucesso',
              color: 'success',
            });
          } catch (error) {
            const { response } = error
            if (
                this.timeOutDetected === false && 
                response.data.errors[0].message.includes('timed out') 
            ){
                this.generateQRCode()
                console.error(error)
                    this.timeOutDetected = true
                }
            }
        },
      authenticationTwoFactor(){
        this.showModal = true
        this.verifyActivity = false
        this.$emit('showModal', false);
      },
      closePopup(value){
        this.showModal = value
      },
      async validateSecretKey() {
        try {
            
          const token = localStorage.getItem('accessToken');
          const email = localStorage.getItem('email');
          await this.$store.dispatch('getAllUsers');
          const response = this.$store.state.users.users;
          const userdata = response.find(user => user.email === email);
          const role = userdata.role.display_name;

          if (this.googleSecret !== '') {
            await this.$store.dispatch('activityTwoFactor', {
              id: userdata.id,
              token: token,
              alterObject: { "google2fa_secret": this.googleSecret, "identify": 0, "role": role, "email": email }
            });
            if(this.messageResponse.data !== '' && this.messageResponse.status === 400)
            {
              this.$vs.notify({
                title: 'Erro!',
                text: this.messageResponse.data,
                color: 'danger',
              });
              this.messageResponse = ''
              return false
            }

            this.$vs.notify({
              title: 'Sucesso!',
              text: 'Autenticação realizada com sucesso, permissões liberadas',
              color: 'success',
            });

            this.$store.dispatch('fetchPermissions', {
              email: email,
              token: token
            });

            const permissions = this.$store.state.permission.permissions;

            localStorage.removeItem('permissions');
            localStorage.setItem('permissions', JSON.stringify(permissions));
            this.showModal = false
            setTimeout(() => {
              this.$router.push('/')
            }, 1000);
          } 
        } catch (error) {
          console.error('Ocorreu um erro:', error);
          this.$vs.notify({
            title: 'Erro!',
            text: 'Ocorreu um erro durante a autenticação',
            color: 'danger',
          });
        }
      },
      handleApiResponse(response) {
        this.messageResponse = response
        return this.messageResponse;
      },
      closePopUpSettings() {
        this.showModal = false;
      }
    },
    created(){
      vue.$on('api-response', this.handleApiResponse);
      this.$events.on('closePopUpSetting', this.closePopUpSettings);
    },
    beforeDestroy() {
      this.$events.off('closePopUpSetting', this.closePopUpSettings);
    }
  };
  </script>
  <style scoped>
    .generateQRCode{
    margin-right: 10px;
  }
  #option1{
    margin-top: 15px;
  }
  .custom-alert {
    width: 100%;
    padding: 16px;
    border: 1px solid #f9ebdd;
    border-radius: 4px;
    background-color:  #f9ebdd;
    color: #ff9f43;
    margin-bottom: 1rem;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    font-weight: 500;
  }
  .separation-line {
    width: 100%;
    border-top: 1px solid #ff9f43;
    margin: 10px 0;
    box-shadow: 0px 4px 6px #ff9f43;
  }
  </style>